import {enUS, ru} from 'date-fns/locale';

const localizationService = {
    ruLanguageCode: 'ru',

    getDateFormatByLanguageCode(language) {
        const worldDateFormat = 'dd MMMM yyyy';
        const USADateFormat = 'MMMM dd yyyy';
        return language === this.ruLanguageCode ? worldDateFormat : USADateFormat;
    },

    getLanguageCode(language) {
        const enUSAUCode = 'en-US';
        return language === this.ruLanguageCode ? this.ruLanguageCode : enUSAUCode;
    },

    getFormatLocale(language) {
        return language === this.ruLanguageCode ? ru : enUS;
    },
};

export default localizationService;

